import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

const JumbotronFeaturedBanner = ({
  jumbotronType,
  jumbotronContainerClassName,
  jumbotronEntityInfoClassName,
  headingEl,
  breadcrumbs,
  entityImageSection,
  featuredImg,
}) => {
  return (
    <div className={cs(jumbotronContainerClassName, jumbotronType)}>
      {/* Entity Featured Image */}
      {featuredImg}
      <div className={cs('JumbotronBanner__wrapper', jumbotronType)}>
        {/* Header Entity Logo Section */}
        {entityImageSection}
        {/* Header Entity Info Section */}
        <div className={`${jumbotronEntityInfoClassName}__container`}>
          <div className={jumbotronEntityInfoClassName}>
            {breadcrumbs}
            {headingEl}
          </div>
        </div>
      </div>
    </div>
  );
};

JumbotronFeaturedBanner.propTypes = {
  jumbotronType: PropTypes.string.isRequired,
  jumbotronContainerClassName: PropTypes.string.isRequired,
  headingEl: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.object,
  entityImageSection: PropTypes.object,
  featuredImg: PropTypes.object.isRequired,
  jumbotronEntityInfoClassName: PropTypes.string.isRequired,
};

export default JumbotronFeaturedBanner;
